enum SHOPPING_CART_CONSTANTS {
    CART_ADD_ITEM = "CART_ADD_ITEM",
    CART_REMOVE_ITEM = "CART_REMOVE_ITEM",
    CART_RESET_MESSAGE = "CART_RESET_MESSAGE",
    CART_UPDATE_QTY = "CART_UPDATE_QTY",
    CART_RESET = "CART_RESET"
}

export default SHOPPING_CART_CONSTANTS;